import { ProposalFormData, ProposalBlockFormData } from '@modules/proposal/ProposalBuilderPage';
import { CourseBuilderBlockFormData } from '@modules/course/CourseBuilder/CourseBuilderPage';
import { CompactUserResponse } from '../account';
import { PresentationBuilderBlockFormData } from '@modules/presentation/PresentationPage/PresentationBuilder/PresentationBuilderPage';
export type ProposalTemplateId = string;

export enum ProposalTemplateStatus {
  publish = 'publish',
  unpublish = 'unpublish',
}

export enum ProposalTemplateType {
  projectList = 'project-list',
}
export interface ProposalTemplateResponse {
  id: ProposalTemplateId;
  name: string;
  type?: ProposalTemplateType | string | null;
  status: ProposalTemplateStatus;
  data?: ProposalFormData;
  liveData?: ProposalFormData;
  folderId: string;
  folderName: string;
  image?: string;
  previewUrl: string;
  createdBy: CompactUserResponse;
  isArchived: boolean;
}

export interface CopyTemplateRequest {
  title: string;
  data: ProposalBlockFormData[];
}

export interface BlockTemplateResponse {
  id: string;
  title: string;
  data: ProposalBlockFormData[] | CourseBuilderBlockFormData[] | PresentationBuilderBlockFormData[];
}
